import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-regular-svg-icons';
import { faCommentDots as faCommentDotsSolid } from '@fortawesome/free-solid-svg-icons';

type RepliesProps = {
  commentId: number,
  repliesCount: number,
  size?: 'small' | 'medium' | 'large',
  isReply: boolean,
  onReply: (id: number) => any
};

const Replies: FC<RepliesProps> = ({
  commentId,
  repliesCount,
  size,
  isReply,
  onReply
}) => {
  const replyHandler = () => {
    if (isReply) onReply(0);
    else onReply(commentId);
  }

  return (
    <div className="flex items-center">
      <FontAwesomeIcon
        icon={isReply ? faCommentDotsSolid : faCommentDots}
        className="cursor-pointer"
        onClick={replyHandler}
      />
      <div className={`ml-2 text-sm ${size === 'large' ? 'text-base' : 'text-sm'}`}>
        {repliesCount}
      </div>
    </div>
  );
};

export default Replies;
